var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.configText)?_c('div',[_c('span',{staticClass:"p-1 mt-1 text-left"},[_vm._v(_vm._s(_vm.configText))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }